import { render, staticRenderFns } from "./DisplayOptions.vue?vue&type=template&id=cd54b062&scoped=true&"
import script from "./DisplayOptions.vue?vue&type=script&lang=ts&"
export * from "./DisplayOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd54b062",
  null
  
)

export default component.exports